import React from "react";
import Input from "./Input";
import defaultLogo from "../images/login_Logo.svg";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { resolveLogoUrl, DEFAULT_THEME } from "../Hooks/useTenantTheme";
import mailIcon from "../images/mailIcon.svg";
import * as yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
const { REACT_APP_BASE_URL } = process.env;

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .required("Email is Required")
    .email("Invalid email format"),
});

const ForgetPWd = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate()
  const themeContext = useTheme();
  const logo = resolveLogoUrl(themeContext?.theme?.logoUrl) || defaultLogo;
  const appName = themeContext?.theme?.appName || DEFAULT_THEME.appName;

  const handleSubmit = async (values, { resetForm }) => {
    try {
      let data = {
        email: values?.email || "",
      };

      await axios
        .post(`${REACT_APP_BASE_URL}/user/forgot-password`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          toast.success('Email sent successfully');
          navigate('/')
        })
        .catch((error) => {
          console.log("password Error", error);
          toast.error(error?.response?.data?.message || "Failed to send email");
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="bg-canvas-primary h-screen">
      <div className="mainContainer flex flex-col justify-center items-center w-full h-full py-12 lg:py-24">
        <div className="bg-canvas-white py-11 px-5 flex gap-2 flex-col items-center rounded-3xl w-[350px]">
          <div>
            <img src={logo} alt="logo" />
          </div>
          <h1 className="text-canvas-primary font-bold text-center">{appName.toUpperCase()}</h1>
          <p className="text-[15px] font-bold leading-5 text-canvas-secondery">
            Let's get you into your account
          </p>
          <div className="flex flex-col items-center">
            <p className="text-[12px] font-outfit font-bold text-canvas-secondery ">
              Tell us one of the following to get started:
            </p>
            <ul className="list-disc text-[12px] font-outfit font-bold text-canvas-secondery">
              <li>Sign-in email address or mobile number</li>
              <li>Recovery phone number</li>
              <li>Recovery email address</li>
            </ul>
          </div>
          <Formik
            enableReinitialize
            validationSchema={validationSchema}
            validateOnChange={false}
            onSubmit={handleSubmit}
            initialValues={{
              email: "",
            }}
          >
            {({ handleSubmit, handleChange, handleBlur, values }) => (
              <Form
                className="flex flex-col gap-2 w-full"
                noValidate
                onSubmit={handleSubmit}
              >
                <div>
                  <Field
                    name="email"
                    type="email"
                    as={Input}
                    value={values?.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    icon={mailIcon}
                    label="email"
                  />
                  <div className="h-4 leading-4 overflow-hidden">
                    <ErrorMessage
                      name="email"
                      component="span"
                      className="text-red-500 text-xs pl-2"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full font-outfit text-[12px] uppercase font-bold bg-canvas-primary text-canvas-white py-3 px-5 rounded-[37px]"
                >
                  CONTINUE
                </button>
              </Form>
            )}
          </Formik>
        </div>
        {/* <Link
          to="/register"
          className="text-canvas-white font-outfit mt-4 font-semibold text-[12px]"
        >
          Don't have an account?
        </Link> */}
      </div>
    </div>
  );
};

export default ForgetPWd;
